import React, { useState, useEffect } from "react";
import { Button, Form, Dropdown, Modal } from "react-bootstrap";
import { GrAnnounce } from "react-icons/gr";
import { IoMdAddCircle } from "react-icons/io";
import { Link } from "react-router-dom";
import { MdEditNotifications } from "react-icons/md";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoNotificationsSharp } from "react-icons/io5";
import { FaEye } from "react-icons/fa";
import "./announcements.css";

export default function EmpAnnouncements() {
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [announcementToDelete, setAnnouncementToDelete] = useState(null);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");  // Search query state

  useEffect(() => {
    const fetchAnnouncements = async () => {
      setLoading(true);
      try {
        const url = searchQuery
          ? `https://backend.ems.uk.hiradentallab.com/api/announcements/search?search=${searchQuery}`
          : "https://backend.ems.uk.hiradentallab.com/api/announcements/announcements"; // Conditional API URL based on search query
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("no announcement found");
        }
        const announcements = await response.json();
        setData(announcements);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncements();
  }, [searchQuery]);  // Dependency array includes searchQuery
  useEffect(() => {
    const fetchAnnouncements = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          "https://backend.ems.uk.hiradentallab.com/api/announcements/announcements"
        );
        if (!response.ok) {
          throw new Error("Failed to fetch announcements");
        }
        const announcements = await response.json();
        setData(announcements);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncements();
  }, []);

  const handleDelete = async () => {
    if (!announcementToDelete) return;
    try {
      const response = await fetch(
        `https://backend.ems.uk.hiradentallab.com/api/announcements/announcements/${announcementToDelete._id}`,
        {
          method: "DELETE",
        }
      );
      if (!response.ok) {
        throw new Error("Failed to delete announcement");
      }
      // Remove the deleted announcement from state
      setData((prevData) =>
        prevData.filter((item) => item._id !== announcementToDelete._id)
      );
    } catch (err) {
      setError(err.message);
    } finally {
      setShowDeleteModal(false); // Close the modal after deletion
      setAnnouncementToDelete(null); // Reset the announcement to delete
    }
  };

  const openDeleteModal = (announcement) => {
    setAnnouncementToDelete(announcement);
    setShowDeleteModal(true);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(data.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(data.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date.getTime())
      ? "N/A"
      : date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
  };

  const handleViewAnnouncement = (announcement) => {
    setSelectedAnnouncement(announcement);
    setShowViewModal(true);
  };
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);  // Update search query
  };
  return (
    <div className="container-fluid">
      <div>
        <h1 className="announcement-title">
          <GrAnnounce /> Announcements
        </h1>
        <hr />
        <h2 className="announcement-subtitle">
          <IoNotificationsSharp /> All Announcements
        </h2>
        <hr />
        <div className="announcement-container">
          <Link to="/add-announcements" style={{ textDecoration: "none" }}>
            <Button
              variant="primary"
              style={{ marginBottom: "15px", marginLeft: "-0.2%" }}
            >
              <IoMdAddCircle /> Add Announcements
            </Button>
          </Link>
          <div className="filter-container">
            <div className="filter-left">
              <Dropdown className="d-inline mx-0" autoClose="inside">
                <Dropdown.Toggle id="dropdown-autoclose-inside">
                  Show Entries
                </Dropdown.Toggle>
                <Dropdown.Menu className="custom-dropdown-menu">
                  <Dropdown.Item href="#">15</Dropdown.Item>
                  <Dropdown.Item href="#">25</Dropdown.Item>
                  <Dropdown.Item href="#">50</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filter-right">
            <Form className="d-flex">
                <Form.Control
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                  className="search-bar"
                  value={searchQuery}  // Bind the input field to searchQuery state
                  onChange={handleSearchChange}  // Handle search input change
                />
              </Form>
            </div>
          </div>
          <div className="table-responsive">
            {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p>Error: {error}</p>
            ) : (
              <table className="table table-striped table-style">
                <thead className="announcement-table-header">
                  <tr className="table-header">
                    <th>SR</th>
                    <th>Title</th>
                    <th>Category</th>
                    <th>Author</th>
                    <th>Created</th>
                    <th>Updated</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={item._id} style={{ textAlign: "center" }}>
                        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                        <td>{item.title}</td>
                        <td>{item.category}</td>
                        <td>{item.author}</td>
                        <td>{formatDate(item.createdAt)}</td>
                        <td>{formatDate(item.updatedAt)}</td>
                        <td>
                          <Button
                            style={{
                              backgroundColor: "#007bff",
                              color: "white",
                              border: "none",
                              marginRight:'5px',
                            }}
                            size="sm"
                            onClick={() => handleViewAnnouncement(item)}
                          >
                            <FaEye />
                          </Button>
                          <Link to={`/edit-announcement/${item._id}`}>
                            <Button variant="warning" size="sm">
                              <MdEditNotifications />
                            </Button>
                          </Link>{" "}
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => openDeleteModal(item)}
                          >
                            <RiDeleteBin5Line />
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">No data available</td>
                    </tr>
                  )}
                </tbody>
                <tfoot className="table-footer">
                  <tr className="announcement-table-footer">
                    <td>Total</td>
                    <td>-</td>
                    <td>{data.length}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            )}
            <div className="pagination-container">
              <div>
                Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
                {Math.min(currentPage * rowsPerPage, data.length)} of{" "}
                {data.length} entries
              </div>
              <nav>
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <a
                      href="/#"
                      className="page-link"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(currentPage - 1);
                      }}
                    >
                      Previous
                    </a>
                  </li>
                  {pageRange().map((pageNumber) => (
                    <li
                      key={pageNumber}
                      className={`page-item ${
                        currentPage === pageNumber ? "active" : ""
                      }`}
                    >
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(pageNumber);
                        }}
                      >
                        {pageNumber}
                      </a>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === Math.ceil(data.length / rowsPerPage)
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <a
                      href="/#"
                      className="page-link"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(currentPage + 1);
                      }}
                    >
                      Next
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this announcement?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* View Announcement Modal */}
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        centered
        size="lg"
        dialogClassName="fancy-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedAnnouncement?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAnnouncement && (
            <>
              <h5>{selectedAnnouncement.title}</h5>
              <p>{selectedAnnouncement.description}</p>
              <p>
                <strong>Category:</strong> {selectedAnnouncement.category}
              </p>
              <p>
                <strong>Author:</strong>{" "}
                {selectedAnnouncement.author || "Admin"}
              </p>
              <p>
                <strong>Message:</strong> {selectedAnnouncement?.content}
              </p>
              <p>
                <strong>Created:</strong>{" "}
                {formatDate(selectedAnnouncement.createdAt)}
              </p>
              <p>
                <strong>Updated:</strong>{" "}
                {formatDate(selectedAnnouncement.updatedAt)}
              </p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer
        style={{backgroundColor:'#ddd'}}
        >
          <Button variant="primary" onClick={() => setShowViewModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
